// import Vue from 'vue'
// import axios from 'axios'
// import swal from 'sweetalert'
const state = {
  indexPack: 0,
  methodPayments: [
    {
      'id': 0,
      'nom': 'espece'
    },
    {
      'id': 1,
      'nom': 'cheque'
    },
    {
      'id': 2,
      'nom': 'virement'
    },
    {
      'id': 3,
      'nom': 'versement'
    }
  ]
}
const mutations = {
  CHOIX_PACK: (state, value) => {
    state.indexPack = value
  }
}
const actions = {
  choixPack (store, value) {
    store.commit('CHOIX_PACK', value)
  }
}
const getters = {
  indexPack: state => state.indexPack,
  methodPayments: state => state.methodPayments
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/store/modules/abonnement.js